import gql from 'graphql-tag'

export const GET_PROJECTS = gql`
  query {
    getProjects {
      Address
      Matter_Name
      billable
      client
      name
      projectCode
      repliconId
      taskIds
      isOpenForTimeEntries
      _id
      StageName
      salesforce_id
      lead
      isFixedBill
      Budget__c
      CurrencyIsoCode
    }
  }
`

export const GET_RATES_BY_PROJECT_LEAD = gql`
  query getRatesByProjectLead($projectLeadId: String!, $selectedDelegateId: String) {
    getRatesByProjectLead(projectLeadId: $projectLeadId, selectedDelegateId: $selectedDelegateId) {
      rates
    }
  }
`

export const GET_KEY_DATES_BY_PROJECT_SF_ID = gql`
  query getKeyDatesByProjectSFId($projectSFId: String!) {
    getKeyDatesByProjectSFId(projectSFId: $projectSFId) {
      keyDates
    }
  }
`

export const GET_EXPENSES_BY_PROJECT_IDS = gql`
  query getExpensesByProjectIds($projectIds: String!) {
    getExpensesByProjectIds(projectIds: $projectIds) {
      expenses
    }
  }
`

export const GET_WIP_SUMMARY_REPORT_DOC = gql`
  query getWipSummaryReportDoc(
    $project: ProjectInput!
    $wipData: WipDataInput!
    $person: PersonInput!
  ) {
    getWipSummaryReportDoc(project: $project, wipData: $wipData, person: $person)
  }
`

export const GET_WIP_DETAILED_REPORT_DOC = gql`
  query getWipDetailedReportDoc(
    $project: ProjectInput!
    $wipData: WipDataInput!
    $keyDates: [KeyDateInput]!
    $oration: String!
    $budgetTrend: String!
    $actualsToDate: String!
    $budgetMonths: [BudgetMonthInput]!
    $pacing: Float
    $invoiceTotals: [WipDataInput]!
    $person: PersonInput!
  ) {
    getWipDetailedReportDoc(
      project: $project
      wipData: $wipData
      keyDates: $keyDates
      oration: $oration
      budgetTrend: $budgetTrend
      actualsToDate: $actualsToDate
      budgetMonths: $budgetMonths
      pacing: $pacing
      invoiceTotals: $invoiceTotals
      person: $person
    )
  }
`

export const GET_WIP_REPORTS_BY_PROJECT_IDS = gql`
  query getWipReportsByProjectIds($projectIds: String!, $months: String!) {
    getWipReportsByProjectIds(projectIds: $projectIds, months: $months) {
      projectId
      monthlyWipReports {
        month
        submittedHours {
          staffHours
          expertHours
          staffRate
          expertRate
        }
        submittedWriteOffs
        submittedExpenses {
          staffExpenses
          expertExpenses
        }
        totalFeesAndExpenses
        wipPacing
        hoursDetails {
          personName
          date
          comment
          hours
          total
        }
        expensesDetails {
          personName
          date
          description
          account
          cost
        }
        budget
        pacingWeek
        invoiceDiscount {
          isPercentage
          value
        }
      }
    }
  }
`

export const GET_PROJECT_INVOICES = gql`
  query getProjectInvoices($projectId: String!) {
    getProjectInvoices(projectId: $projectId) {
      _id
      due_date
      name
      paid
      dateActivated
      status
      projects
      amount
      ship_date
      startDate
      deleted
      invoiceDiscount {
        type
        value
      }
      projectDiscount {
        type
        value
      }
      sections {
        amount
        split
        quickbooksId
      }
    }
  }
`

export const GET_PROJECT_OVERVIEW = gql`
  query getProjectOverview($projectId: String!) {
    getProjectOverview(projectId: $projectId) {
      project {
        name
        endDate
        currency
      }
      months {
        month
        demand
        cappedDemand
        staffed
        monthToDateSubmitted
        pacing
        revenueForecast
      }
      personLevel {
        month
        persons {
          personId
          name
          role
          staffStart
          staffEnd
          allocation
          rate
          staffed
          pacing
        }
      }
    }
  }
`

export const GET_FILTERED_TIME_ENTRIES = gql`
  query {
    getTimeEntries {
      projectId
      timeEntries {
        _id
        sourceId
        repliconTimesheetId
        originalPersonId
        personId
        originalRepliconPersonId
        repliconPersonId
        comment
        entryDate
        originalEntryDate
        durationInHours
        duration {
          hours
          minutes
          seconds
          milliseconds
          microseconds
        }
        billable
        estimatedRunRate
        projectId
        repliconProjectId
        repliconProjectTaskId
        status
        originalDurationInHours
        originalComment
        originalProjectId
        source
        isClientProject
        quickbooksInvoiceId
        invoicingParent
        invoicingConstituents
        start
        end
        splitParent
        splitChildren
        referenceId
        referenceType
        createdBy
        creationWay
        eventTagId
        approveState
      }
    }
  }
`

export const UPDATE_PROJECT_INVOICE = gql`
  mutation updateProjectInvoice($invoiceId: String!, $invoiceData: InvoiceInput!) {
    updateProjectInvoice(invoiceId: $invoiceId, invoiceData: $invoiceData) {
      _id
      due_date
      name
      paid
      dateActivated
      status
      projects
      invoiceDiscount {
        type
        value
      }
      projectDiscount {
        type
        value
      }
      sections {
        amount
      }
    }
  }
`

export const EXPORT_INVOICE_DATA = gql`
  mutation ExportInvoiceData($invoiceData: InvoiceExportDataInput!) {
    exportInvoiceData(invoiceData: $invoiceData)
  }
`
